import { createContext, useContext, useEffect, useState } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile,
  sendPasswordResetEmail,
} from 'firebase/auth';
import { auth, db, storage } from '../firebase';
import { setDoc, doc } from 'firebase/firestore';
import { getDownloadURL, ref } from "firebase/storage";

const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});

  const createUser = async (
        fname,
        lname,
        email,
        password,
        userEducation,
        userExperience,
        softSkills,
        userAbout,
        userPortfolio,
        userCoverPhoto
  ) => {
    try {
       const { user } = await createUserWithEmailAndPassword(
         auth,
         email,
         password
       );
       await updateProfile(auth.currentUser, {
         displayName: fname + ' ' + lname,
         userCoverPhoto: userCoverPhoto,

         dateCreated: new Date().toISOString(),
       });
       await setDoc(doc(db, 'users', user.uid), {
         uid: user.uid,
         email: user.email,
         name: user.displayName,
         userEducation: userEducation,
          userExperience: userExperience,
          softSkills: softSkills,
          userAbout: userAbout,
          userPortfolio: userPortfolio,
          userCoverPhoto: userCoverPhoto,
         dateCreated: user.metadata.creationTime,
       });
     setUser(user);
     } catch (error) {
       console.log(error);
     }
 };


   const signIn = (email, password) =>  {
    return signInWithEmailAndPassword(auth, email, password)
   }

  const logout = () => {
      return signOut(auth)
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log(currentUser);
      setUser(currentUser);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider value={{ createUser, user, logout, signIn }}>
      {children}
    </UserContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
